import React from 'react';

/**
 * PremiumGate — Verrouillage de fonctionnalités Premium
 * 
 * - Premium ✅ : affiche le contenu normalement
 * - Grandfathered ✅ : affiche le contenu avec un badge "Transition"
 * - Free 🔒 : désactive le contenu + affiche un overlay cadenas "💎 Premium"
 *
 * Props:
 * - feature {string} — Identifiant de la fonctionnalité (is_free, lrc, analytics...)
 * - artist {object} — Données de l'artiste (subscription_tier, grandfathered_until)
 * - label {string} — Message d'info-bulle pour les utilisateurs Free
 * - children {ReactNode} — Contenu à wrappper
 */
export default function PremiumGate({ feature, artist, label, children }) {
  // Déterminer si l'artiste a accès
  const isPremium = artist?.subscription_tier === 'premium';
  
  const isGrandfathered = 
    !isPremium && 
    artist?.grandfathered_until &&
    new Date(artist.grandfathered_until) > new Date();

  const hasAccess = isPremium || isGrandfathered;

  // Premium ou Grandfathered → accès libre (sans badge Transition)
  if (hasAccess) {
    return (
      <div className="premium-gate-wrapper premium-gate-unlocked" data-feature={feature}>
        {children}
      </div>
    );
  }

  // Free → verrouillé
  return (
    <div 
      className="premium-gate-wrapper premium-gate-locked" 
      data-feature={feature}
      title={label}
      style={{
        position: 'relative',
        opacity: 0.45,
        cursor: 'not-allowed',
        userSelect: 'none',
        filter: 'grayscale(0.6)',
      }}
    >
      {/* Overlay bloquant les interactions */}
      <div 
        style={{
          position: 'absolute',
          inset: 0,
          zIndex: 5,
          cursor: 'not-allowed',
        }}
        aria-disabled="true"
      />
      
      {/* Badge Premium */}
      <span 
        className="premium-gate-badge premium-badge"
        style={{
          position: 'absolute',
          top: '-8px',
          right: '-8px',
          zIndex: 10,
          background: 'linear-gradient(135deg, #f59e0b, #d97706)',
          color: '#fff',
          fontSize: '0.6rem',
          fontWeight: 700,
          padding: '2px 8px',
          borderRadius: '100px',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '4px',
          boxShadow: '0 2px 8px rgba(245, 158, 11, 0.4)',
          letterSpacing: '0.5px',
          whiteSpace: 'nowrap',
        }}
      >
        <i className="fa-solid fa-crown" style={{ fontSize: '0.55rem' }}></i>
        Premium
      </span>

      {children}
    </div>
  );
}
